var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25 25H15C10.3983 25 6.66663 28.7317 6.66663 33.3333H33.3333C33.3333 28.7317 29.6016 25 25 25Z",
    fill: "#015BBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.87 10C23.1567 10.4917 23.3333 11.0567 23.3333 11.6667C23.3333 13.505 21.8383 15 20 15C18.1617 15 16.6667 13.505 16.6667 11.6667C16.6667 11.0567 16.8433 10.4917 17.13 10H13.57C13.43 10.5367 13.3333 11.0883 13.3333 11.6667C13.3333 15.3433 16.3233 18.3333 20 18.3333C23.6767 18.3333 26.6667 15.3433 26.6667 11.6667C26.6667 11.0883 26.57 10.5367 26.43 10H22.87ZM20 23.3333C14.765 23.3333 5 25.91 5 30.8333V35H35V30.8333C35 25.91 25.235 23.3333 20 23.3333ZM31.6667 31.6667H8.33333V30.8333C8.33333 29.385 14.5133 26.6667 20 26.6667C25.4867 26.6667 31.6667 29.385 31.6667 30.8333V31.6667Z",
    fill: "#015BBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6884 23.8534L20 31.6667L15.3117 23.8534H24.6884ZM25.8334 1.66675H14.1667C14.1667 1.66675 13.3334 8.33342 13.3334 11.6667H26.6667C26.6667 8.33342 25.8334 1.66675 25.8334 1.66675ZM16.8334 8.33342C16.9234 7.19508 17.0367 6.02008 17.1434 5.00008H22.8567C22.9634 6.02008 23.0784 7.19508 23.1667 8.33342H16.8334Z",
    fill: "#015BBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15 3.33325H25V9.99992H15V3.33325Z",
    fill: "#015BBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.7c318e1ac23331212132c8e3f95d2ab9.svg";
export { ForwardRef as ReactComponent };